import React, { useState } from 'react';
import { Modal, message } from 'antd';

interface RejectModalProps {
    visible: boolean;
    fileId: number | null;
    onClose: () => void;
    onSuccess: () => void;
}

const RejectModal: React.FC<RejectModalProps> = ({ visible, fileId, onClose, onSuccess }) => {
    const [loading, setLoading] = useState(false);

    const handleReject = async () => {
        if (!fileId) return;

        setLoading(true);
        try {
            const token = localStorage.getItem("loginToken");
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/campaign/reject-file/${fileId}`,
                {
                    method: 'POST',
                    headers: {
                        "Authorization": `Bearer ${token}`,
                        "Content-Type": "application/json"
                    }
                }
            );

            if (response.ok) {
                message.success('File rejected successfully!');
                onSuccess();
                onClose();
            } else {
                message.error('Failed to reject file');
            }
        } catch (error) {
            console.error(error);
            message.error('Error rejecting file');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Reject File"
            open={visible}
            onCancel={onClose}
            onOk={handleReject}
            okText="Reject"
            okButtonProps={{ danger: true }}
            confirmLoading={loading}
        >
            <p>Are you sure you want to reject this file?</p>
        </Modal>
    );
};

export default RejectModal;
